import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col} from 'reactstrap';
import {AUcallout} from '@gov.au//callout';
import Question from '../../../components/CASAForm/Question';
import StepNavigation from '../../../components/CASAForm/StepNavigation';
import {addCourseCode} from '../../../FormStore/Actions/FormDataActions/MPL/AddMPLFormData'
import {getFormDataSelector, getFormServiceStatusSelector} from "../../../FormStore/Selectors/FormDataSelectors";
import {addPageAlert, clearPageAlert} from "../../../PortalStore/Actions/PageAlertActions";
import CustomBackLink from "../../../components/CASAForm/ReusableQuestions/CustomBackLink";
import AUtextInput from '@gov.au/text-inputs';

class MPLAddCourseCode extends Component {
    constructor(props) {
        super(props);

        let courseCode = '',
            courseOutcome = '',
            courseDescription = '';

        if (props.formData.courseCode) {
            courseCode = props.formData.courseCode;
            courseOutcome = props.formData.courseOutcome;
            courseDescription = props.formData.courseDescription;
        }

        this.state = {
            courseCode: courseCode,
            courseOutcome: courseOutcome,
            courseDescription: courseDescription,
            showError: false
        }
    }

    returnCourseDetails = (returnedQuestion) => {
        if (returnedQuestion.answer) {
            let courseDetails = this.getCourseDetails(returnedQuestion.answer.value);
            let courseCode = "", courseOutcome = "", courseDescription = "";
            if (courseDetails?.masterDataCourseCode) {
                courseCode = returnedQuestion.answer.value;
                courseOutcome = this.getCourseOutcome(courseDetails.masterDataCourseCode, courseDetails.ratingEntry);
                courseDescription = courseDetails.masterDataCourseName
            }
            this.setState({
                courseCode: courseCode,
                courseOutcome: courseOutcome,
                courseDescription: courseDescription
            })
        }
    };

    nextStep = () => {
        if (this.state.courseCode) {
            this.props.dispatch(addCourseCode({
                courseCode: this.state.courseCode,
                courseDescription: this.state.courseDescription,
                courseOutcome: this.state.courseOutcome
            }))
            this.props.onNextClick({
                courseCode: this.state.courseCode,
                courseDescription: this.state.courseDescription,
                courseOutcome: this.state.courseOutcome
            });
            this.props.dispatch(clearPageAlert());
        } else {
            this.setState({showError: true})
            this.props.dispatch(addPageAlert({
                level: "error",
                title: "Course code not found",
                message: "Please check the course code and try again"
            }));
        }
    }

    previousStep = (e) => {
        e.preventDefault();
        this.props.pageAlert?.level && this.props.dispatch(clearPageAlert());
        this.props.onPreviousClick();
    }

    getCourseOutcome = (courseCode, ratingEntry) => {
        let courseOutcomeValue = ''
        if (courseCode.trim().toUpperCase().endsWith("T")) {
            courseOutcomeValue = "Theory";
        } else if (courseCode.trim().toUpperCase().endsWith("T/P")) {
            courseOutcomeValue = "Theory/Practical";
        } else if (courseCode.trim().toUpperCase().endsWith("P")) {
            courseOutcomeValue = "Practical";
        } else {
            courseOutcomeValue = ratingEntry;
        }

        return courseOutcomeValue;
    }

    getCourseDetails = (courseCodeSelected) => {
        if (this.props.mtoCertificateDetails?.data?.trainingCourses) {
            let suggestions = this.props.mtoCertificateDetails?.data?.trainingCourses;
            if (suggestions?.length > 0) {
                for (const [index, value] of suggestions.entries()) {
                    if (value.masterDataCourseCode === courseCodeSelected) {
                        return value
                    }
                }
            }
        }
        return null;
    }

    getSuggestionsData = () => {
        let filteredSuggestions = [];
        if (this.props.mtoCertificateDetails?.data?.trainingCourses) {
            const suggestions = this.props.mtoCertificateDetails?.data?.trainingCourses;
            if (suggestions?.length > 0) {
                filteredSuggestions = suggestions.map(suggestion => {
                    return {key: suggestion.masterDataSyncId, value: suggestion.masterDataCourseCode}
                }).sort((a, b) => {
                    return a.value > b.value ? 1 : -1;
                })
            }
        }
        return filteredSuggestions;
    }

    render() {
        return (
            <div id={this.props.id}>
                <CustomBackLink
                    id="previousStep"
                    action={this.previousStep}
                    text="Back"
                    direction="left"/>

                <Col
                    className="float-none"
                    lg={6}
                    md={6}>
                    <AUcallout
                        title="Course code"
                        srOnlyTitle>
                        <h3>Course code</h3>
                        <p>This notification will cover one course code only, you can add multiple students to one
                            course code. However, if you wish to submit multiple notifications for different course
                            codes, you will need to complete the submission of one course before attempting to notify
                            CASA of another.</p>
                    </AUcallout>
                </Col>

                <h3 dangerouslySetInnerHTML={{__html: this.props.properties.title}}></h3>

                <Question
                    id="courseCodeSuggestions"
                    stepid="courseCode"
                    type="autoComplete"
                    label="Course code"
                    returnQuestionData={this.returnCourseDetails}
                    showError={this.state.showError}
                    noSuggestionErrorMessage="Please check the course code"
                    existingAnswer={this.state.courseCode ? {
                        key: this.state.courseCode,
                        value: this.state.courseCode
                    } : null}
                    suggestions={this.getSuggestionsData()}/>

                {/*Below input field is added as a workaround to avoid redirection when enter is clicked on the auto suggest field
                 This happens only when there is only one text field in the page, so added another one. This we need to look later*/}
                <AUtextInput
                    id="workaroundComponent"
                    className="hide"
                />

                <div className="form-controls au-form-group">
                    <StepNavigation
                        type='next'
                        action={this.nextStep}/>
                </div>
            </div>
        )
    }
}

MPLAddCourseCode.propTypes = {
    mtoCertificateDetails: PropTypes.object.isRequired,
    properties: PropTypes.object,
    id: PropTypes.string,
    onPreviousClick: PropTypes.func,
    dispatch: PropTypes.func,
    onNextClick: PropTypes.func,
    pageAlert: PropTypes.object,
    formData: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        formData: getFormDataSelector(state.formStore, 'mplFormData'),
        mtoCertificateDetails: getFormServiceStatusSelector(state.formStore, 'getMtoCertificate'),
        pageAlert: state.pageAlert
    }
}

export default connect(mapStateToProps)(MPLAddCourseCode);